import { CmsBlock } from "./cms-block.model";

export class CmsPage {
    id:number;
    path:string;
    title:string;
    description:string;
    blocks:CmsBlock[];
    active:boolean;
}